// extracted by mini-css-extract-plugin
export var screensaver = "screensaver-module--screensaver--2xcgl";
export var logo = "screensaver-module--logo--dLHA1";
export var x = "screensaver-module--x--1t6TY";
export var y = "screensaver-module--y--1l_cA";